<template>
    <div class='widget'>
        <div class='content'>            
            <div class='question'>{{item.reverse ? info.reverseQuestion : info.question}}</div>
            <div class='term'>{{item.text}}</div>
            <template v-if='useLetters()'>
                <div class='options'>
                    <div v-for='(o,i) in item.options' :key='o' class='image'>
                        <span class='letter'>{{String.fromCharCode(65+i)}}</span>
                        <span class='option'>{{o}}</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import baseMinigame from '../baseMinigame';
import i18n from '@root/components/i18n';

export default {
    mixins: [baseMinigame, i18n],
    data() {
        return {
        }
    },
    emits: ["setAnswer"],
    props: ["item"],
    beforeMount() {
    },
    methods: {
        useLetters() {
            let maxlength = Math.max(0, ...this.item.options.map(c=>c.length));
            return maxlength > 24;
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'gameTypes';

    .widget {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        background: rgba(255,255,255,0.7);
    }
    .content {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        //justify-content: center;
        justify-content: space-evenly;
        align-items: center;
    }

    .question {
        display: block;
        margin: 8px 0;
    }
    .letter {
        font-weight: 1000;
        font-size: 1.1em;
        margin-right: 8px;
    }
    .option {

    }
    .term {
        display: block;
        font-size: 2em;
        font-weight: 600;
        margin: 8px 8px;
        text-align: center;
    }
</style>

<i18n>
    {
        en: {
            Answer: "Answer",
        },
        ru: {
            Answer: "Ответ",
        }
    }
</i18n>